import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AppState } from 'src/app/app.state';
import { PropertyFilterService } from '../../service/property-filter.service';

@Component({
  selector: 'app-property-filter-bar',
  templateUrl: './property-filter-bar.component.html',
  styleUrls: ['./property-filter-bar.component.scss'],
})
export class PropertyFilterBarComponent implements OnInit {
  constructor(
    public _route: ActivatedRoute,
    public _domSanitizer: DomSanitizer,
    public propertyFilterService: PropertyFilterService,
    public appState: AppState
  ) {}
  alternateCompanyName: string = '';

  ngOnInit() {
    this.alternateCompanyName = this.appState && this.appState.companyInfoValue.alterNativeName;
  }

  /**
   * @private
   */
  _applyFilter(filter: string): void {
    this.propertyFilterService.setCustomFilterToUrl(filter);
  }

  /** @private */
  _getIconStyle(url: string) {
    // 'mask:url(' + _domSanitizer.bypassSecurityTrustUrl(filter.icon) + ') no-repeat center / contain'
    return this._domSanitizer.bypassSecurityTrustStyle('url(' + url + ') no-repeat center / contain');
  }
}
